// extracted by mini-css-extract-plugin
export default {"container":"TextSection_container__RMTYp","title":"TextSection_title__8MOwy","text":"TextSection_text__mm6zz","blur1":"TextSection_blur1__mOCig","blur2":"TextSection_blur2__6chIb"};